<template>
    <BaseTextImage
        v-bind="$props"
        :pending="pending"
        :use-parallax="true"
    >
        <template #text>
            <NewsletterForm
                :token="listId"
                :consent-id="consentId"
            />
        </template>

        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
            :key="name"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>
    </BaseTextImage>
</template>

<script setup>


defineProps({
    image: {
        type: Object,
        default: null,
    },
    pending: {
        type: Boolean,
        default: false,
    },
    listId: {
        type: String,
        default: undefined,
    },
    consentId: {
        type: String,
        default: undefined,
    },
    backgroundColor: {
        type: String,
        default: null,
    },
    customBackgroundColor: {
        type: String,
        default: null,
    },
});
</script>
